import type { AxiosInstance } from 'axios';
import { VORSCHLAEGE_PFAD, DUPLIKATE_PFAD } from './menue';

/**
 * Was in der Verwaltung offen ist, je Menüpunkt (`pfad` aus VERWALTUNG_MENUE) — einmal für Web
 * und App. Jeder Abruf darf scheitern (fehlende Rechte, Netz), dann zählt er 0 statt die ganze
 * Navigation mitzureißen.
 *
 * Die Reiter-Seiten (Vorschläge, Duplikate) tragen ihre Teilzahlen unter eigenen Schlüsseln und
 * die Summe unter dem Menüpfad.
 */
export const OFFEN_REITER = {
  eventVorschlaege: `${VORSCHLAEGE_PFAD}/events`,
  veranstalterVorschlaege: `${VORSCHLAEGE_PFAD}/veranstalter`,
  bildVorschlaege: `${VORSCHLAEGE_PFAD}/bilder`,
  eventDuplikate: `${DUPLIKATE_PFAD}/events`,
  veranstalterDuplikate: `${DUPLIKATE_PFAD}/veranstalter`,
} as const;

export type OffeneZaehler = Record<string, number>;

export async function ladeOffeneZaehler(api: AxiosInstance): Promise<OffeneZaehler> {
  const hol = <T>(p: Promise<{ data: T }>): Promise<T | null> => p.then(r => r.data).catch(() => null);
  const [eventEdits, bilder, eventDups, orgDups, orgEdits, neuerungen, anfragen, zugaenge, buchungen, outreach] =
    await Promise.all([
      hol<{ totalElements: number }>(api.get('/event-edits/pending', { params: { page: 0, size: 1 } })),
      hol<{ count: number }>(api.get('/event-image-proposals/pending-count')),
      hol<unknown[]>(api.get('/events/duplicates')),
      hol<unknown[]>(api.get('/organizers/duplicates')),
      hol<{ totalElements: number }>(api.get('/organizer-edits/pending', { params: { page: 0, size: 1 } })),
      hol<{ count: number }>(api.get('/release-notes/unread-count')),
      hol<{ count: number }>(api.get('/inquiries/unhandled-count')),
      hol<{ count: number }>(api.get('/organizer-access/pending-count')),
      hol<{ count: number }>(api.get('/admin/bookings/counts')),
      hol<{ count: number }>(api.get('/admin/outreach/unread-count')),
    ]);
  const z: OffeneZaehler = {
    [OFFEN_REITER.eventVorschlaege]: eventEdits?.totalElements ?? 0,
    [OFFEN_REITER.veranstalterVorschlaege]: orgEdits?.totalElements ?? 0,
    [OFFEN_REITER.bildVorschlaege]: bilder?.count ?? 0,
    [OFFEN_REITER.eventDuplikate]: eventDups?.length ?? 0,
    [OFFEN_REITER.veranstalterDuplikate]: orgDups?.length ?? 0,
    '/admin/neuerungen': neuerungen?.count ?? 0,
    '/admin/anfragen': anfragen?.count ?? 0,
    '/organizers/zugaenge': zugaenge?.count ?? 0,
    '/admin/buchungen': buchungen?.count ?? 0,
    '/admin/outreach': outreach?.count ?? 0,
  };
  z[VORSCHLAEGE_PFAD] = z[OFFEN_REITER.eventVorschlaege] + z[OFFEN_REITER.veranstalterVorschlaege] + z[OFFEN_REITER.bildVorschlaege];
  z[DUPLIKATE_PFAD] = z[OFFEN_REITER.eventDuplikate] + z[OFFEN_REITER.veranstalterDuplikate];
  return z;
}
